<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div>
    <page-header class="py-4 pb-6">
      {{ $t('printTemplate') }}
      <template #action>
        <v-item-group
          v-model="tab"
          mandatory
        >
          <div class="d-flex">
            <v-spacer v-if="!$vuetify.breakpoint.mdAndUp" />
            <v-item v-slot="{active,toggle}">
              <v-btn
                :class="active?'amber lighten-4 black--text':''"
                :icon="!$vuetify.breakpoint.mdAndUp"
                :outlined="!active"
                :style="!active ? 'background-color: white;' : ''"
                class="mr-2"
                elevation="0"
                @click="toggle"
              >
                <v-icon
                  :left="$vuetify.breakpoint.mdAndUp"
                  color="black"
                >
                  mdi-file-document-edit
                </v-icon>
                <span
                  v-if="$vuetify.breakpoint.mdAndUp"
                  class="text-truncate"
                  style="max-width: 170px;"
                >
                  {{ $t('change_model') }}
                </span>
              </v-btn>
            </v-item>
            <v-item
              v-slot="{active,toggle}"
            >
              <v-btn
                :class="active?'amber lighten-4 black--text':''"
                :icon="!$vuetify.breakpoint.mdAndUp"
                :outlined="!active"
                :style="!active ? 'background-color: white;' : ''"
                class="mr-2"
                elevation="0"
                @click="toggle"
              >
                <v-icon
                  :left="$vuetify.breakpoint.mdAndUp"
                  color="black"
                >
                  mdi-file-cog
                </v-icon>
                <span
                  v-if="$vuetify.breakpoint.mdAndUp"
                  class="text-truncate"
                  style="max-width: 170px;"
                >
                  {{ $t('bill_info_setting') }}
                </span>
              </v-btn>
            </v-item>
            <v-item v-slot="{active,toggle}">
              <v-btn
                :class="active?'amber lighten-4 black--text':''"
                :icon="!$vuetify.breakpoint.mdAndUp"
                :outlined="!active"
                :style="!active ? 'background-color: white;' : ''"
                elevation="0"
                @click="toggle"
              >
                <v-icon
                  :left="$vuetify.breakpoint.mdAndUp"
                  color="black"
                >
                  mdi-list-status
                </v-icon>
                <span
                  v-if="$vuetify.breakpoint.mdAndUp"
                  class="text-truncate"
                  style="max-width: 170px;"
                >
                  {{ $t('daily_content_setting') }}
                </span>
              </v-btn>
            </v-item>
          </div>
        </v-item-group>
      </template>
    </page-header>
    <loading-provider :loading="mainPageLoading">
      <div
        v-if="!loading"
        class="mt-4"
      >
        <v-tabs-items
          v-model="tab"
          style="background: transparent"
        >
          <v-tab-item>
            <div
              class="mt-4"
            >
              <v-alert
                class="mb-4"
                dense
                text
                type="info"
              >
                {{ $t('printTemplateReadonlyHint') }}
              </v-alert>
              <v-card
                v-for="c in classList"
                :key="c.class"
                class="text-body-1 py-2 d-flex align-center px-4 mb-4"
                outlined
                @click="editItem(c.class)"
              >
                {{ $t(c.class) }}
                <v-spacer />
                <v-btn text>
                  <v-icon left>
                    mdi-eye
                  </v-icon>
                  {{ $t('detail') }}
                </v-btn>
              </v-card>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div
              class="pa-4"
              style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 24px"
            >
              <div>
                <div
                  class="text-h4 font-weight-bold"
                >
                  {{ $t('billInfo') }}
                </div>
                <div
                  class="text-subtitle-1 mt-2"
                >
                  {{ $t('billEnding') }}
                </div>
                <div class="text-caption">
                  {{ $t('billEndingRule') }}
                </div>
                <v-textarea
                  v-model="getEnding"
                  class="mt-4"
                  dense
                  height="150"
                  hide-details
                  outlined
                />
                <div
                  class="text-subtitle-1 mt-4"
                >
                  QRCode
                </div>
                <div class="text-caption">
                  {{ $t('ifInputShowLast') }}
                </div>
                <v-text-field
                  v-model="getQRCode"
                  class="mt-4"
                  dense
                  hide-details
                  outlined
                />
              </div>
              <div>
                <div class="text-h4 font-weight-bold">
                  {{ $t('LOGO') }}
                </div>
                <div class="mt-2">
                  <div class="text-subtitle-1">
                    {{ $t('orderPrintLogo') }}
                  </div>
                  <div class="text-caption">
                    {{ $t('onlyUseBlackWhiteLogo') }}
                  </div>
                  <v-card
                    class="pa-2 mt-2"
                    color="#fafbfc"
                    elevation="0"
                    height="200px"
                    style="position: relative"
                    width="200px"
                  >
                    <div
                      style="position:absolute;top: 8px;
                                          left: 8px;right: 8px;bottom:8px;margin:auto;border-radius: 12px"
                    >
                      <v-img
                        :src="bonLogo"
                        style="border-radius: 12px"
                      />
                    </div>
                    <v-file-input
                      accept="image/*"
                      class="mt-2"
                      counter
                      dense
                      height="200px"
                      outlined
                      style="opacity: 0;cursor: pointer"
                      width="200px"
                      @change="processFile"
                    />
                  </v-card>
                </div>
              </div>
            </div>
            <div
              class="px-4 pb-4"
              style="width: 100%"
            >
              <v-btn
                class="amber lighten-4 black--text"
                elevation="0"
                @click="saveEnding"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                {{ $t('save') }}
              </v-btn>
            </div>
          </v-tab-item>
          <v-tab-item>
            <v-card
              v-if="bonSettingInfo"
              class="pa-4"
              outlined
            >
              <div
                v-for="item in bonSetting"
                :key="item.key"
                class="d-flex align-center"
              >
                <div
                  class="text-body-1"
                >
                  {{ item.label }}
                </div>
                <v-spacer />
                <v-switch
                  v-model="bonSettingInfo[item.key]"
                  false-value="0"
                  hide-details
                  true-value="1"
                />
              </div>
              <div class="d-flex mt-4">
                <v-btn
                  class="amber lighten-4 black--text"
                  elevation="0"
                  @click="postBonSettingInfo"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  {{ $t('save') }}
                </v-btn>
              </div>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </loading-provider>
    <nice-dialog
      v-model="dialog"
      width="calc(100vw - 300px)"
    >
      <v-container
        :class="!$vuetify.breakpoint.lgAndUp ? '' : 'px-6'"
        class="d-flex flex-column"
      >
        <div class="d-flex align-center">
          <back-button
            class="mr-4"
            @close-event="dialog=false"
          />
          <page-sub-header>{{ $t('printTemplateEdit') }}/{{ $t(currentClass) }}</page-sub-header>
        </div>

        <template v-if="currentTemplate">
          <div
            :style="!$vuetify.breakpoint.lgAndUp ? 'grid-template-columns: repeat(1fr); max-width: 360px; margin: auto;' : 'grid-template-columns: repeat(2,1fr);'"
            style="display: grid;position: relative;grid-gap: 24px"
          >
            <div
              :class="!$vuetify.breakpoint.lgAndUp ? 'order-1' : ''"
              class="mt-4"
            >
              <div class="text-overline">
                {{ $t('stylePreview') }}
              </div>
              <v-card
                outlined
                style="overflow-y: scroll"
              >
                <template-render
                  :bon-class="currentClass"
                  :content="currentTemplate.content"
                  class="pa-2"
                />
              </v-card>
            </div>
            <div
              :class="!$vuetify.breakpoint.lgAndUp ? 'order-0' : ''"
              class="mt-4"
              style="position: sticky;top: 0px; background: rgb(250, 251, 252)"
            >
              <div class="pa-2">
                <div class="text-overline">
                  {{ $t('currentlySelectedTemplate') }}
                </div>
                <v-select
                  v-model="currentBonId"
                  :item-text="(item)=>item.id+'/'+(item.remark||'No Remark')"
                  :items="bonList"
                  :menu-props="{offsetY:true, outlined:true,contentClass:'elevation-2 ikRounded',nudgeBottom:'16px'}"
                  item-value="id"
                  outlined
                />
                <v-text-field
                  v-model="currentTemplate.remark"
                  label="remark"
                  outlined
                  readonly
                />
                <v-textarea
                  v-model="currentTemplate.content"
                  height="50vh"
                  outlined
                  readonly
                />
                <!-- 打印模板改到 ERP 统一修改 (有版本、可回滚), 这里只读, 避免两边改造成门店模板和云端版本不一致 -->
                <v-alert
                  dense
                  text
                  type="info"
                >
                  {{ $t('printTemplateReadonlyHint') }}
                </v-alert>
              </div>
            </div>
          </div>
        </template>
      </v-container>
    </nice-dialog>
  </div>
</template>

<script>

import Utils from '@/model/utils/IkUtils/Utils'
import {
  deleteBonTemplate,
  getBonTemplateClassList,
  getBonTemplateList,
  updateBonTemplate
} from '@/model/dataLayer/api/print/bonTemplate'
import PageHeader from '@/views/widget/typography/PageHeader'
import PageSubHeader from '@/views/widget/typography/PageSubHeader'
import NiceDialog from '@/views/widget/uiComponent/NiceDialog.vue'
import { orderBy } from 'lodash-es'
import TemplateRender from '@/views/AadenPages/print/fragment/TemplateRender'
import BackButton from '@/views/widget/uiComponent/BackButton.vue'
import { getBonEnding, getBonSetting, postBonEnding, postBonSetting } from '@/model/dataLayer/api/print/PrintSetting'
import { getRestaurantInfo } from '@/model/dataLayer/service/otherService'
import hillo from 'hillo'
import i18n from '@/i18n'
import { showSuccessMessage } from '@/model/utils/utils'
import { getRootUrl } from '@/model/global/GlobalSettings'
import LoadingProvider from '@/views/widget/LoadingProvider'

const notReadyBons = [
  'DishSalesBon',
  'FreeInformationBon',
  'GutScheinBon',
  'InformationBon',
  'KitchenSticker',
  'QueueNumberBon',
  'RealTimeDishSalesBon',
  'SalesInSightBon',
  'ServantBon',
  'TableQRBon',
  'ZBON',
  'ZwischenBon'

]
const bonSetting = [
  {
    key: 'zbon_showStornoDetails',
    label: i18n.t('showReturnDishDetail')
  },
  {
    key: 'zbon_showDiscountDetails',
    label: i18n.t('showDiscountDetail')
  },
  {
    key: 'zbon_showCashAccount',
    label: i18n.t('showCashBook')
  },
  {
    key: 'zbon_showServantSummary',
    label: i18n.t('showStaffSummary')
  },
  {
    key: 'zbon_showStatisticSection',
    label: i18n.t('showStatistics')
  }
]

export default {
  components: {
    LoadingProvider,
    TemplateRender,
    PageSubHeader,
    PageHeader,
    NiceDialog,
    BackButton
  },
  data: function () {
    return {
      mainPageLoading: false,
      getQRCode: null,
      editedItem: {
        bonLogo: ''
      },
      editBonLogo: '',
      uploadBonLogoFile: null,
      bonSetting,
      bonSettingInfo: null,
      getEnding: null,
      tab: null,
      loading: true,
      dialog: false,
      bonList: [],
      classList: [],
      editedIndex: -1,
      currentClass: '',
      currentBonId: 0

    }
  },
  computed: {
    bonLogo: function () {
      return this.editedItem.bonLogo
    },
    currentTemplate (val) {
      console.log(this.bonList.find(it => it.id === this.currentBonId), '321')
      return this.bonList.find(it => it.id === this.currentBonId)
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    async reload () {
      this.mainPageLoading = true
      this.loading = true
      this.classList = (await getBonTemplateList()).filter(it => !notReadyBons.includes(it.class))
      this.getEnding = (await getBonEnding()).content.checkout_ending
      this.QRCode = (await getBonEnding()).content.checkout_customQR
      if (this.QRCode.includes('http')) {
        this.getQRCode = this.QRCode
      } else {
        this.getQRCode = 'http://' + this.QRCode
      }
      this.bonSettingInfo = (await getBonSetting()).content
      const res = await getRestaurantInfo()
      this.editedItem = res.content[0]
      if (this.editedItem.bonLogo) {
        const tmpArr = this.editedItem.bonLogo.split('/../')
        this.editedItem.bonLogo = getRootUrl() + tmpArr[1]
      }
      this.loading = false
      this.mainPageLoading = false
    },
    processFile (event) {
      this.uploadBonLogoFile = event
      this.editedItem.bonLogo = URL.createObjectURL(event)
    },
    async postBonSettingInfo () {
      await postBonSetting(this.bonSettingInfo)
      await this.reload()
      showSuccessMessage()
    },
    async saveEnding () {
      if (!this.getQRCode.includes('http')) {
        this.getQRCode = 'http://' + this.getQRCode
      }
      const res = {
        checkout_ending: this.getEnding,
        checkout_customQR: this.getQRCode
      }
      await postBonEnding(res)
      if (this.uploadBonLogoFile) {
        await hillo.postWithUploadFile('Restaurant.php?op=changeBonLogo', {
          file: this.uploadBonLogoFile
        })
      }

      await this.reload()
      showSuccessMessage()
    },
    async reloadItem () {
      this.bonList = orderBy(await getBonTemplateClassList(this.currentClass),
        ['sectionSort', 'id'], ['asc', 'desc'])
      this.currentBonId = this.bonList[0].id
    },
    editItem (bonClass) {
      this.currentClass = bonClass
      this.reloadItem()
      this.dialog = true
    },
    async deleteItem (item) {
      await deleteBonTemplate(item.id)
      Utils.toast('Successful!')
      await this.reload()
    },
    async save () {
      this.loading = true
      const reqs = this.bonList.map(async it => await updateBonTemplate(it.id, 20, it.content, it.remark))
      await Promise.all(reqs)
      await updateBonTemplate(this.currentBonId, 0, this.currentTemplate.content, this.currentTemplate.remark)
      Utils.toast('Successful!')
      this.close()
      await this.reload()
    },
    close () {
      this.dialog = false
    },
    scrollToBottom () {
      setTimeout(() => {
        this.$vuetify.goTo(9999)
      }, 200)
    }
  }
}
</script>
